<template>
 <button 
    v-bind="$attrs"
    @click="onClickHandler"
    :class="chipClass"
    style="padding-top:5px; padding-bottom: 5px"
    class="rounded-pill  px-4 me-3">
    <slot></slot>
  </button>
</template>
  
<script>
export default {
  props: {
    value: {
      type: [String, Number],
      default: null
    },
    setLGButton:Boolean
  },
  computed: {
    active() {
      return this.value && this.$parent.chipGroupSelectedValue && this.$parent.chipGroupSelectedValue.includes(this.value)
    },
    chipClass() {
      console.log("setLGButton",this.setLGButton)
      if(this.setLGButton){
        return {
          'btn  btn-lg btn-secondary': !this.active,
          'btn  btn-lg btn-primary': this.active
        }
      }else{
        return {
          'btn  btn-sm btn-light': !this.active,
          'btn  btn-sm btn-primary': this.active
        }
      }
      
    }
  },
  methods: {
    onClickHandler() {
      this.$emit("click");
      this.$parent.onSelectHandler && this.$parent.onSelectHandler(this.value);
    }
  }
}
</script>
